import React from 'react';
import ReactDOM from 'react-dom';
import './index2.css';
import { Provider } from 'react-redux';
import App from './components/App';
import store from './util/store';

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>
    , document.getElementById('root')
);
